import { GzDialogWebComponent } from '../../../ui/gzDialog';
import { GzDialogEvents } from '../../../ui/gzDialog/component/GzDialog';

export function getDeleteDialogButtons(translateFn: Function): HTMLElement {
  const buttonsWrapper = document.createElement('div');

  buttonsWrapper.innerHTML = `
    <gz-button type="outline" color="negative" data-confirm="true">
      ${translateFn('delete')}
    </gz-button>
    <gz-button type="outline" color="secondary" data-cancel="true">
      ${translateFn('cancel')}
    </gz-button>
  `;

  return buttonsWrapper;
}

export function attachDialogFooterListeners(
  element: HTMLElement,
  dialog: GzDialogWebComponent,
  confirmCallback?: Function,
  cancelCallback?: Function
): void {
  element.querySelector('[data-confirm]')?.addEventListener(
    'click',
    () => {
      if (confirmCallback) {
        confirmCallback();
        return;
      }

      dialog.emitDialogEvent(GzDialogEvents.CONFIRM);
    },
    { once: true }
  );

  element.querySelector('[data-cancel]')?.addEventListener(
    'click',
    () => {
      if (cancelCallback) {
        cancelCallback();
        return;
      }
      dialog.emitDialogEvent(GzDialogEvents.CANCEL);
    },
    { once: true }
  );
}
